import React, { useState } from "react";
import Carousel from "antd/lib/carousel";
import Image from "antd/lib/image";
import defaultImg from "../../assets/WidgetMaker/Brocken_Image.svg";
import isEqual from "react-fast-compare";
import VideoPreview from "./VideoPreview";
import moment from "moment";
import uuid from "react-uuid";
import { useSelector } from "react-redux";

const CarouselWidgetMaker = ({
  el,
  height,
  postCardDetails,
  deepDive,
  isViewFullImage,
  gallaryCardHeight,
  isAutoPlay = true,
  brandPostHeight,
  isPreviewAllowed = true,
  isMediaContainScreen = false,
  isDeepDiveDashboardView = false,
}) => {
  const authParams = useSelector((state) => state.Authentication.authParams);
  const [visible, setVisible] = useState(false);
  const [isImage, setIsImage] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [videoPreview, setVideoPreview] = useState();
  const [isValidUrlFlag, setIsValidUrlFlag] = useState(null);
  const enumConfig = useSelector((state) => state?.apiCall?.enumConfig);
  const onImageError = (e) => {
    if (e?.type === "error") {
      setIsImage(true);
    } else {
      setIsImage(false);
    }
    return (e.target.src = defaultImg);
  };

  const isScontentLinkExpire = (mediaUrl, channelType) => {
    let isExpired = false;
    try {
      if (
        mediaUrl &&
        mediaUrl?.indexOf("s3.amazonaws") == -1 &&
        mediaUrl?.indexOf("images.locobuzz.com") == -1
      ) {
        const tokens = mediaUrl?.split("&");
        const HexDecimalCode = tokens?.filter((x) => x?.includes("oe="));
        if (
          HexDecimalCode != null &&
          HexDecimalCode?.length > 0 &&
          HexDecimalCode?.[0]?.startsWith("oe=")
        ) {
          let DecimalEpoch = 0;
          if (HexDecimalCode?.length > 0) {
            const HexDecimalTime = HexDecimalCode?.[0]?.replace("oe=", "");
            DecimalEpoch = parseInt(HexDecimalTime, 16);
          }
          // DateTimeOffset.Now.ToUnixTimeSeconds()
          if (moment().unix() > DecimalEpoch && DecimalEpoch > 0) {
            isExpired = true;
          }
        }
      }
    } catch (exception) {
      return false;
    }

    return isExpired;
  };

  const handleVideoPreview = (imgUrl) => {
    setIsModalOpen(true);
    setVideoPreview(imgUrl?.MediaUrl);

    let isValidUrlFlag = isScontentLinkExpire(imgUrl?.MediaUrl, 1);
    setIsValidUrlFlag(isValidUrlFlag);
  };

  const getPlatformOrChannelId = (channelNameOrID) => {
    let socialMediaPlatformObj = enumConfig?.SocialMediaPlatforms;
    if (typeof channelNameOrID === "string") {
      const indexOfMedia = Object.keys(socialMediaPlatformObj).find(
        (key) =>
          socialMediaPlatformObj[key].toLowerCase() ===
          channelNameOrID.toLowerCase()
      );
      return parseInt(indexOfMedia);
    }
  };
  let carouselId = `Carousel_Media_${uuid()}`;
  return (
    <>
      <Carousel
        autoplay={isAutoPlay}
        dots={false}
        arrows
        className="dotsClass bg__gray carouselDiv"
        style={{
          height:
            authParams?.screen_id === "000-000-562" && !isDeepDiveDashboardView
              ? brandPostHeight
              : gallaryCardHeight
              ? gallaryCardHeight
              : window.location.pathname?.split("/")?.[3] === "000-000-551" &&
                !deepDive &&
                !isDeepDiveDashboardView &&
                !isViewFullImage
              ? "8rem"
              : window.location.pathname?.split("/")?.[3] === "000-000-551" &&
                !deepDive &&
                !isDeepDiveDashboardView &&
                isViewFullImage
              ? "auto"
              : postCardDetails
              ? "30rem"
              : "20rem",
        }}
        id={carouselId}
        key={carouselId}
      >
        {el?.Attachment?.map((imgUrl, i) => {
          let PlatformID;
          if (!el?.PlatformID || el?.PlatformID === 0) {
            PlatformID = el?.SocialMediaPlatforms
              ? getPlatformOrChannelId(el?.SocialMediaPlatforms)
              : el?.ChannelName
              ? getPlatformOrChannelId(el?.ChannelName)
              : el?.Channel
              ? getPlatformOrChannelId(el?.Channel)
              : "";
          }
          return (
            <div
              className="w-100 text-center position-relative attachment_image"
              key={`imgUrl${carouselId}${i}`}
            >
              {imgUrl?.MediaType === "2" || imgUrl?.MediaType === "4" ? (
                <>
                  <Image
                    src={
                      imgUrl?.ThumbUrl
                        ? imgUrl?.ThumbUrl
                        : imgUrl?.MediaUrl
                        ? imgUrl?.MediaUrl
                        : defaultImg
                    }
                    alt="Preview Group"
                    fallback={defaultImg}
                    preview={isPreviewAllowed}
                    style={{
                      width: "100%",
                      height:
                        authParams?.screen_id === "000-000-562" &&
                        !isDeepDiveDashboardView
                          ? brandPostHeight
                          : gallaryCardHeight
                          ? gallaryCardHeight
                          : window.location.pathname?.split("/")?.[3] ===
                              "000-000-551" &&
                            !deepDive &&
                            !isDeepDiveDashboardView &&
                            !isViewFullImage
                          ? "8rem"
                          : window.location.pathname?.split("/")?.[3] ===
                              "000-000-551" &&
                            !deepDive &&
                            !isDeepDiveDashboardView &&
                            isViewFullImage
                          ? "auto"
                          : postCardDetails
                          ? "30rem"
                          : "20rem",
                      objectFit: isMediaContainScreen ? "contain" : "cover",
                      margin: "0rem",
                    }}
                    onError={(el) => onImageError(el, i)}
                  />
                </>
              ) : imgUrl?.MediaType === "3" || imgUrl?.MediaType === "7" ? (
                <>
                  {[2, 4, 37]?.includes(el?.PlatformID) ||
                  [2, 4, 37]?.includes(PlatformID) ? (
                    <a
                      href={imgUrl?.MediaUrl ? imgUrl?.MediaUrl : ""}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        src={imgUrl?.ThumbUrl ? imgUrl?.ThumbUrl : defaultImg}
                        alt="Attachment Images"
                        onError={(el) => onImageError(el, i)}
                      />
                    </a>
                  ) : [1, 3, 5, 42]?.includes(el?.PlatformID) ||
                    [1, 3, 5, 42]?.includes(PlatformID) ? (
                    <>
                      <div
                        style={{
                          height:
                            authParams?.screen_id === "000-000-562" &&
                            !isDeepDiveDashboardView
                              ? brandPostHeight
                              : gallaryCardHeight
                              ? gallaryCardHeight
                              : window.location.pathname?.split("/")?.[3] ===
                                  "000-000-551" &&
                                !deepDive &&
                                !isDeepDiveDashboardView &&
                                !isViewFullImage
                              ? "8rem"
                              : postCardDetails
                              ? "30rem"
                              : "20rem",
                        }}
                        class="overlay-play-button"
                        onClick={() => handleVideoPreview(imgUrl)}
                      >
                        <video
                          width="100%"
                          style={{
                            objectFit: isMediaContainScreen
                              ? "contain"
                              : "cover",
                            height:
                              authParams?.screen_id === "000-000-562" &&
                              !isDeepDiveDashboardView
                                ? brandPostHeight
                                : gallaryCardHeight
                                ? gallaryCardHeight
                                : window.location.pathname?.split("/")?.[3] ===
                                    "000-000-551" &&
                                  !deepDive &&
                                  !isDeepDiveDashboardView &&
                                  !isViewFullImage
                                ? "8rem"
                                : postCardDetails
                                ? "30rem"
                                : "20rem",
                          }}
                          poster={imgUrl?.ThumbUrl ? imgUrl?.ThumbUrl : ""}
                          className="gallary--video"
                        >
                          <source src={imgUrl?.MediaUrl} type="video/mp4" />
                        </video>

                        <div class="overlay-play-button__overlay">
                          <div class="overlay-play-button__play">
                            <i
                              class="fa fa-play"
                              style={{ fontSize: "1.2rem", color: "#fff" }}
                            ></i>
                          </div>
                        </div>
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                </>
              ) : (
                ""
              )}
            </div>
          );
        })}
      </Carousel>
      <VideoPreview
        videoPreview={videoPreview}
        setIsModalOpen={setIsModalOpen}
        isModalOpen={isModalOpen}
        isValidUrlFlag={isValidUrlFlag}
      />
    </>
  );
};

export default React.memo(CarouselWidgetMaker, isEqual);
